export default "__VITE_ASSET__DJB_wQsB__"